//@state
export interface fileManagementState {
  fileManagement:boolean,
  resource:String,
  resource_id:String,
  attachment_temp_code:Array<object>
}

export const initialState: fileManagementState = {
  fileManagement: true,
  resource: '',
  resource_id: '',
  attachment_temp_code:[]
}
